import { Spinner, Box } from '@chakra-ui/react'
import { createElement } from 'react'

import { useAppRoute } from 'routes/utils'

import { InlineError } from 'components'

import { EntitySearchType } from 'api/types'
import { useCollectionDataSingleRaw } from 'api/useCollectionDataSingle'

import { IModel } from 'interfaces/model.interface'
import { IBaseView } from 'interfaces/navigationPage.interface'

import EntityPreviewDetailViewBase from './EntityPreviewDetailView'
import { appsListUnion } from 'config/apps'

type PropTypes = {
  model: IModel<any>
  entityData: EntitySearchType
  app?: appsListUnion
}

export default function EntityPreview({ app, model, entityData }: PropTypes) {
  const currentApp = useAppRoute()
  const selectedApp = app || currentApp

  const { isLoading, data, error } = useCollectionDataSingleRaw(
    selectedApp,
    model?.endpoint,
    entityData.id,
    { airtableBase: entityData.base as IBaseView<any>['airtableBase'] }
  )

  return (
    <>
      {isLoading && (
        <Box display='flex' height='100%' minH='200px'>
          <Spinner margin='auto' />
        </Box>
      )}
      {error && <InlineError />}
      {!isLoading &&
        data &&
        createElement(EntityPreviewDetailViewBase, {
          model,
          data,
        })}
    </>
  )
}
